<template>
    <ValidationObserver class="mt-4" ref="form" v-slot="{handleSubmit}">
        <vs-row vs-type="flex">
            <vs-col vs-w="6">
                <div class="mr-2">
                    <ValidationProvider
                        vid="name"
                        name="Name"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <vs-input class="w-full" label-placeholder="Name" v-model="name"/>
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="ml-2">
                    <ValidationProvider
                        vid="url"
                        name="URL"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <vs-input class="w-full" label-placeholder="URL" v-model="url"/>
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </vs-col>
        </vs-row>
        <div class="mt-4 text-right">
            <vs-button color="primary" @click="handleSubmit(submit)" type="filled">{{$t('buttons.Save')}}</vs-button>
        </div>
    </ValidationObserver>
</template>

<script>
import ErrorHandler from '@/utils/errorHandler'
import EventBus from '@/store/eventBus'
import {ValidationObserver, ValidationProvider} from 'vee-validate'

export default {
    props: ['popupData', 'popupType', 'popupButton'],
    data() {
        return {
            name: '',
            url: ''
        }
    },

    components:{
        ValidationProvider,
        ValidationObserver,
    },

    methods: {
        async submit() {
            try {
                const data = {
                    name: this.name,
                    url: this.url,
                    affiliate_hash: this.popupData.hash
                }

                await this.$store.dispatch('ADD_TRACKER', data)
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (error) {

                if(error.response) {
                    const response = error.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }

                new ErrorHandler(error).send
            }
        }
    },

    mounted() {
        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>
